module.exports = __webpack_public_path__ + "static/media/100_BookCover.b9a7568e.jpg";